export function stripFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return fileName;
    }
    return fileName.slice(0, lastDotIndex);
}

export function getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return '';
    }
    return fileName.slice(lastDotIndex);
}

const NON_LETTER_OR_DIGIT_PATTERN = new RegExp('[^\\p{L}\\p{N}]+', 'gu');

export const MAX_EXPORT_FILE_NAME_LENGTH = 60;

export function toSafeExportFileName(value: string, fallback: string): string {
    return (
        value
            .trim()
            .toLowerCase()
            .replace(NON_LETTER_OR_DIGIT_PATTERN, '-')
            .replace(/^-+|-+$/g, '') || fallback
    );
}

export function safeExportFileBaseName(
    value: string,
    fallback: string,
): string {
    return toSafeExportFileName(value, fallback).slice(
        0,
        MAX_EXPORT_FILE_NAME_LENGTH,
    );
}

export function fileNameFromContentDisposition(
    header?: string,
): string | undefined {
    if (!header) {
        return undefined;
    }
    const encoded = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (encoded) {
        return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ''));
    }
    const plain = header.match(/filename="?([^";]+)"?/i);
    return plain ? plain[1].trim() : undefined;
}

export function resolveDownloadFileName(
    requested: string,
    serverFileName?: string,
): string {
    const serverExtension = serverFileName
        ? getFileExtension(serverFileName).toLowerCase()
        : '';
    if (!serverExtension || requested.toLowerCase().endsWith(serverExtension)) {
        return requested;
    }
    return `${stripFileExtension(requested)}${serverExtension}`;
}
